import { createPortal } from 'react-dom';
import { Printer, X } from 'lucide-react';
import Button from './Button';

// Full-screen overlay holding a printable document (fee receipt, due ledger,
// report card). Only `.print-area` is visible when printing — see the
// @media print rules in styles/tokens.css.
export default function PrintSheet({ title, onClose, children, landscape = false }) {
  return createPortal(
    <div className="fixed inset-0 z-[1500] bg-[rgba(16,27,34,0.55)] overflow-y-auto print-overlay" onClick={onClose}>
      <div className={`${landscape ? 'max-w-[1100px]' : 'max-w-[780px]'} mx-auto my-8 px-4`} onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3 no-print">
          <span className="font-display font-bold text-white text-[15px]">{title}</span>
          <div className="flex gap-2">
            <Button onClick={() => window.print()} className="flex items-center gap-1.5"><Printer size={15} /> Print</Button>
            <Button variant="secondary" onClick={onClose} className="flex items-center gap-1.5"><X size={15} /> Close</Button>
          </div>
        </div>
        <div className={`print-area bg-white text-[#101b22] rounded-m shadow-2 p-8 ${landscape ? 'print-landscape' : ''}`}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

// Standard letterhead for every printed document.
export function PrintHeader({ schoolName, docTitle, right }) {
  return (
    <div className="flex items-start justify-between border-b-2 border-[#101b22] pb-3 mb-5">
      <div>
        <div className="font-display font-extrabold text-xl">{schoolName}</div>
        <div className="text-[13px] font-bold uppercase tracking-wider text-[#405058] mt-0.5">{docTitle}</div>
      </div>
      {right && <div className="text-right text-[12.5px] text-[#405058]">{right}</div>}
    </div>
  );
}
